import './BatchActivitiesCompleteExecutor.scss';
import React, { useCallback, useState } from 'react';
import { DocumentExecutionService } from '@services/actions/DocumentExecutionService';
import Modal from '@atoms/Modal';
import clsx from 'clsx';
import Button from '@atoms/Button';
import { MdClose } from 'react-icons/md';
import Preloader from '@atoms/Preloader';
import Hint from '@atoms/Hint';
import Textarea from '@atoms/Textarea';
import { IBatchActivitiesCompleteExecutorProps } from './IBatchActivitiesCompleteExecutorProps';

export const BatchActivitiesCompleteExecutorModal: React.FC<IBatchActivitiesCompleteExecutorProps> = (
    props: IBatchActivitiesCompleteExecutorProps,
) => {
    const [comment, setComment] = useState<string>();
    const [errorText, setErrorText] = useState<string>();
    const [loading, setLoading] = useState<boolean>();
    const service = new DocumentExecutionService(props.docId);

    const onSubmit = useCallback(() => {
        setLoading(true);

        // Сохранение данных
        service
            .batchActivitiesComplete(props.actionKey, comment)
            .then(() => {
                props.completeHandler && props.completeHandler(true);
            })
            .catch((error) => setErrorText(error))
            .finally(() => {
                setLoading(false);
            });
    }, [comment]);

    return (
        <Modal
            className={clsx('modal-dlg-container')}
            size={props.modalSize}
            header={
                <div className={clsx('box')}>
                    <div>
                        <span>{props.title}</span>
                    </div>
                    <div className={clsx('left')}>
                        <Button
                            buttonType="text"
                            textColor="neutral"
                            size="xs"
                            aria-label="Закрыть окно"
                            onClick={() => {
                                if (props?.completeHandler) props?.completeHandler(false);
                            }}
                            startAdornment={<MdClose size="24" />}
                        />
                    </div>
                </div>
            }
            footer={
                <div className="modal-dlg-buttons">
                    <Button onClick={onSubmit} size="s" aria-label={props.okButtonText} disabled={loading}>
                        {props.okButtonText}
                    </Button>
                    <Button
                        buttonType="light"
                        size="s"
                        aria-label={props.cancelButtonText}
                        onClick={() => {
                            if (props.completeHandler) props.completeHandler(false);
                        }}
                        disabled={loading}
                    >
                        {props.cancelButtonText}
                    </Button>
                </div>
            }
        >
            {loading ? (
                <Preloader size="m" position="static" />
            ) : (
                <div className="actForm">
                    {errorText && <Hint title={`Ошибка: ${errorText}`} variant="red" maxWidth={'100%'} />}

                    <Textarea
                        className="action-modal-dlg-input"
                        placeholder="Комментарий"
                        rows={6}
                        name="commentText"
                        onChange={(e: any) => {
                            setComment(e.target.value);
                        }}
                    />
                </div>
            )}
        </Modal>
    );
};
